/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const sendMail = /* GraphQL */ `
  query SendMail($contact: Contact, $disposals: [Disposal]) {
    sendMail(contact: $contact, disposals: $disposals)
  }
`;
